module.exports = __webpack_public_path__ + "img/loader.6cbf00b2.svg";